import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b1a163aa")

_pushScopeId("data-v-b1a163aa")
const _hoisted_1 = { class: "shell" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_list = _resolveComponent("list")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_list, {
      headers: _ctx.headers,
      action: false,
      update: _ctx.updateToList,
      "list-data": _ctx.listRequestData,
      "selected-item": _ctx.selectItem,
      "show-check": "OnlyCheck",
      "is-clear-check": false,
      onMultipleSelect: _ctx.updateSelectData
    }, null, 8, ["headers", "update", "list-data", "selected-item", "onMultipleSelect"])
  ]))
})